import Permission from "permissions/permission";
import { PermissionParams } from "permissions/_schemas/permission-schema";
import { PermissionTemplateParams } from "permissions/templates/_schemas/permission-template-schema";
import { PermissionsByGranteeParams } from "permissions/by-grantee/_schemas/permissions-by-grantee-schema";
import { LegalEntityAccessType, LegalEntitiesPlatformAccessType } from "permissions/resources/legal-entities/legal-entity-access-types";
import type { Resource } from "permissions/resources/permission-resource";
import { ChildResourceType, ResourceConstructor, ResourceType } from "permissions/resources/permission-resource-types";
import { LoginAccessType } from "permissions/resources/users/login-access-type";

export type ChildResourceConstructorMap = Record<keyof typeof ChildResourceType, ResourceConstructor>;

export const AccessTypeEnumByResourceType = {
  [ResourceType.LegalEntityAccess]: LegalEntityAccessType,
  [ResourceType.LegalEntitiesPlatformAccess]: LegalEntitiesPlatformAccessType,
  [ResourceType.LoginAccess]: LoginAccessType,
};

export type PermissionCtorParams = Omit<PermissionParams, "resource" | "parentPermissions"> & {
  resource: Resource;
  parentPermissions?: Permission[];
};

export type PermissionTemplateCtorParams = Omit<PermissionTemplateParams, "resources"> & {
  resources: Resource[];
};

export type PermissionsByGranteeCtorParams = Omit<PermissionsByGranteeParams, "recentPermissionsPreview"> & {
  recentPermissionsPreview: Permission[];
};
